import React from 'react';
import { Container, Carousel } from 'react-bootstrap';
import { motion,  } from 'framer-motion';

// Custom CSS can be added here or in a separate CSS file.
// For this example, some inline styles are used for simplicity.
const customStyles = `
  body {
      overflow-x: hidden; /* Prevent horizontal scroll from animations */
  }

  .partners-section {
    background-color: #0d8080; /* Teal background from image */
    padding: 50px 0;
    overflow: hidden; /* Hide the overflowing logos */
  }

  .partners-section h2 {
    color: white;
    font-weight: bold;
    text-decoration: underline;
    text-underline-offset: 8px;
  }

  .partners-slider-container {
    width: 100%;
    display: flex;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(to right, transparent, #000 10%, #000 90%, transparent);
    mask-image: linear-gradient(to right, transparent, #000 10%, #000 90%, transparent);
  }

  .partners-track {
    display: flex;
  }

  .partner-logo {
    height: 60px;
    margin: 0 40px;
    filter: brightness(0) invert(1) grayscale(1); /* Make logos white */
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }
  .partner-logo:hover {
    opacity: 1;
  }
  
  .carousel-caption {
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 10px;
  }
  
  .section-heading {
      color: #0056b3;
      font-weight: bold;
      text-transform: uppercase;
  }
`;

const App = () => {
    // --- Data for the sections ---

    const newsData = [
        {
            img: 'assets/images/sections/Hny.jpg',
            title: 'Happy New Year 2025',
            caption: 'Wishing everyone a prosperous and joyful new year from the Vikash team.'
        },
        {
            img: 'assets/images/sections/rep.jpg',
            title: 'Republic Day Celebration',
            caption: 'Celebrating the spirit of India on Republic Day with our community.'
        },
        {
            img: 'assets/images/sections/clean.jpg',
            title: 'Project GreenEarth Launched',
            caption: 'We are excited to announce our new initiative to promote local green spaces.'
        }
    ];

  

    return (
        <>
            <style>{customStyles}</style>
            {/* Bootstrap CDN added via link in head, assuming this is possible in the host environment. 
                If not, some Bootstrap styles might not apply correctly. */}
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
                xintegrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM"
                crossOrigin="anonymous"
            />
            <div className="App" style={{ backgroundColor: '#f8f9fa' }}>

                {/* ======================= */}
                {/* ===== NEWS & EVENTS ==== */}
                {/* ======================= */}
                <Container className="my-5">
                    <h2 className="text-center mb-4 section-heading">News & Events</h2>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <Carousel fade>
                            {newsData.map((news, index) => (
                                <Carousel.Item key={index}>
                                    <img
                                        className="d-block w-100 rounded"
                                        src={news.img}
                                        alt={news.title}
                                    />
                                    <Carousel.Caption className="d-none d-md-block">
                                        <h5>{news.title}</h5>
                                        <p>{news.caption}</p>
                                    </Carousel.Caption>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </motion.div>
                </Container>

               

            </div>
        </>
    );
}

export default App;

